"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElecReadingMultiInput = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../shared/core");
var copy_1 = require("../copy");
var MeterReadsDatepicker_1 = require("./MeterReadsDatepicker");
var ElecReadingMultiInput = function (_a) {
    var ids = _a.ids, errors = _a.errors, meterNumOfDigits = _a.meterNumOfDigits, isUpdating = _a.isUpdating, meterReading = _a.meterReading, onChange = _a.onChange, start = _a.start, setDate = _a.setDate, isOnboarding = _a.isOnboarding;
    var NumberField = (0, core_1.useComponents)().NumberField;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var offPeakErrorMsg = errors && errors.offpeak;
    var peakErrorMsg = errors && errors.peak;
    var dateErrorMsg = errors && errors.multiDate;
    var meterReadingMultipleInputOffpeakLabel = !isOnboarding
        ? copy('readingMultipleInputOffpeakLabel')
        : copy('readingMultipleInputOffpeakLabelToday');
    var meterReadingMultipleInputPeakLabel = !isOnboarding
        ? copy('readingMultipleInputPeakLabel')
        : copy('readingMultipleInputPeakLabelToday');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(NumberField, { "data-testid": ids.offpeak, id: ids.offpeak, label: meterReadingMultipleInputOffpeakLabel, value: meterReading.offpeak, onChange: onChange('offpeak'), hint: offPeakErrorMsg !== copy('readingMultipleInputHintText') &&
                copy('readingMultipleInputHintText'), error: offPeakErrorMsg, characters: meterNumOfDigits || 25, disabled: isUpdating, iconLeft: "offpeakLegacy", affixWidth: 40 }),
        react_1.default.createElement(NumberField, { "data-testid": ids.peak, id: ids.peak, label: meterReadingMultipleInputPeakLabel, value: meterReading.peak, onChange: onChange('peak'), hint: peakErrorMsg !== copy('readingMultipleInputHintText') &&
                copy('readingMultipleInputHintText'), error: peakErrorMsg, characters: meterNumOfDigits || 25, disabled: isUpdating, iconLeft: "peakLegacy", affixWidth: 40 }),
        !isOnboarding ? (react_1.default.createElement(MeterReadsDatepicker_1.MeterReadsDatepicker, { id: ids.multiDate, error: dateErrorMsg, supplyStartDate: start, setDate: setDate, fuel: "electricity" })) : null));
};
exports.ElecReadingMultiInput = ElecReadingMultiInput;
